var map = {
	"./en/analyze.json": [
		24807,
		4807
	],
	"./en/article.json": [
		64601,
		4601
	],
	"./en/auth.json": [
		62723,
		2723
	],
	"./en/chart.json": [
		45692,
		5692
	],
	"./en/chat.json": [
		58330,
		8330
	],
	"./en/common.json": [
		74053,
		4053
	],
	"./en/countries.json": [
		45592,
		5592
	],
	"./en/error.json": [
		12369,
		2369
	],
	"./en/explore.json": [
		76382,
		6382
	],
	"./en/header.json": [
		70867,
		867
	],
	"./en/helperWidget.json": [
		34665,
		4665
	],
	"./en/iconography.json": [
		68227,
		8227
	],
	"./en/myToggle.json": [
		37127,
		7127
	],
	"./en/onboarding.json": [
		12567,
		2567
	],
	"./en/paywall.json": [
		18585,
		8585
	],
	"./en/portfolio.json": [
		47733,
		7733
	],
	"./en/seo.json": [
		40842,
		842
	],
	"./en/settings.json": [
		46841,
		6841
	],
	"./en/subscription.json": [
		13290,
		3290
	],
	"./en/widget.json": [
		25554,
		5554
	],
	"./es/analyze.json": [
		23208,
		3208
	],
	"./es/article.json": [
		55991,
		5991
	],
	"./es/auth.json": [
		23545,
		3545
	],
	"./es/chart.json": [
		9178,
		9178
	],
	"./es/chat.json": [
		16721,
		6721
	],
	"./es/common.json": [
		31952,
		1952
	],
	"./es/countries.json": [
		59148,
		9148
	],
	"./es/error.json": [
		41832,
		1832
	],
	"./es/explore.json": [
		15630,
		5630
	],
	"./es/header.json": [
		70551,
		551
	],
	"./es/helperWidget.json": [
		10390,
		390
	],
	"./es/iconography.json": [
		58964,
		8964
	],
	"./es/myToggle.json": [
		79454,
		9454
	],
	"./es/onboarding.json": [
		68413,
		8413
	],
	"./es/paywall.json": [
		54126,
		4126
	],
	"./es/portfolio.json": [
		95692,
		805
	],
	"./es/seo.json": [
		81574,
		1574
	],
	"./es/settings.json": [
		22150,
		2150
	],
	"./es/subscription.json": [
		93733,
		3733
	],
	"./es/trading.json": [
		14830,
		4830
	],
	"./es/turbo-chart.json": [
		81529,
		1529
	],
	"./es/widget.json": [
		48536,
		8536
	],
	"./ja/analyze.json": [
		12887,
		2887
	],
	"./ja/article.json": [
		46660,
		6660
	],
	"./ja/auth.json": [
		21063,
		1063
	],
	"./ja/chart.json": [
		35514,
		5514
	],
	"./ja/chat.json": [
		82213,
		3005
	],
	"./ja/common.json": [
		44664,
		4664
	],
	"./ja/countries.json": [
		59201,
		9201
	],
	"./ja/error.json": [
		8629,
		8629
	],
	"./ja/explore.json": [
		71553,
		1553
	],
	"./ja/header.json": [
		18280,
		8280
	],
	"./ja/helperWidget.json": [
		6661,
		6661
	],
	"./ja/iconography.json": [
		9247,
		9247
	],
	"./ja/myToggle.json": [
		75588,
		5588
	],
	"./ja/onboarding.json": [
		11308,
		1308
	],
	"./ja/paywall.json": [
		63285,
		3285
	],
	"./ja/portfolio.json": [
		6384,
		6384
	],
	"./ja/seo.json": [
		87369,
		7369
	],
	"./ja/settings.json": [
		5209,
		5209
	],
	"./ja/subscription.json": [
		47375,
		7375
	],
	"./ja/trading.json": [
		94815,
		4815
	],
	"./ja/turbo-chart.json": [
		12481,
		2481
	],
	"./ja/widget.json": [
		37014,
		1951
	],
	"./ko/analyze.json": [
		1254,
		1254
	],
	"./ko/article.json": [
		32159,
		2159
	],
	"./ko/auth.json": [
		78106,
		8106
	],
	"./ko/chart.json": [
		4235,
		4235
	],
	"./ko/chat.json": [
		16176,
		6176
	],
	"./ko/common.json": [
		16700,
		6700
	],
	"./ko/countries.json": [
		84445,
		4445
	],
	"./ko/error.json": [
		15097,
		5097
	],
	"./ko/explore.json": [
		85015,
		5015
	],
	"./ko/header.json": [
		45895,
		5895
	],
	"./ko/helperWidget.json": [
		54342,
		4342
	],
	"./ko/iconography.json": [
		69433,
		9433
	],
	"./ko/myToggle.json": [
		32213,
		2213
	],
	"./ko/onboarding.json": [
		51578,
		1578
	],
	"./ko/paywall.json": [
		8736,
		8736
	],
	"./ko/portfolio.json": [
		90365,
		365
	],
	"./ko/seo.json": [
		79661,
		9661
	],
	"./ko/settings.json": [
		21707,
		1707
	],
	"./ko/subscription.json": [
		38772,
		8772
	],
	"./ko/trading.json": [
		8472,
		8472
	],
	"./ko/turbo-chart.json": [
		69369,
		9369
	],
	"./ko/widget.json": [
		23017,
		3017
	],
	"./pt-BR/analyze.json": [
		35698,
		5698
	],
	"./pt-BR/article.json": [
		86572,
		6572
	],
	"./pt-BR/auth.json": [
		15351,
		5351
	],
	"./pt-BR/chart.json": [
		29011,
		9011
	],
	"./pt-BR/chat.json": [
		61333,
		1333
	],
	"./pt-BR/common.json": [
		79991,
		9991
	],
	"./pt-BR/countries.json": [
		63724,
		3724
	],
	"./pt-BR/error.json": [
		93564,
		3564
	],
	"./pt-BR/explore.json": [
		78629,
		369
	],
	"./pt-BR/header.json": [
		29934,
		9934
	],
	"./pt-BR/helperWidget.json": [
		54529,
		4529
	],
	"./pt-BR/iconography.json": [
		7014,
		7014
	],
	"./pt-BR/myToggle.json": [
		47407,
		7407
	],
	"./pt-BR/onboarding.json": [
		32170,
		2170
	],
	"./pt-BR/paywall.json": [
		38162,
		8162
	],
	"./pt-BR/portfolio.json": [
		66541,
		6541
	],
	"./pt-BR/seo.json": [
		77266,
		7266
	],
	"./pt-BR/settings.json": [
		53390,
		3390
	],
	"./pt-BR/subscription.json": [
		1768,
		1768
	],
	"./pt-BR/trading.json": [
		57789,
		7789
	],
	"./pt-BR/turbo-chart.json": [
		2730,
		2730
	],
	"./pt-BR/widget.json": [
		23333,
		3333
	],
	"./pt/analyze.json": [
		46004,
		6004
	],
	"./pt/article.json": [
		69246,
		9246
	],
	"./pt/auth.json": [
		84805,
		4805
	],
	"./pt/chart.json": [
		75935,
		5935
	],
	"./pt/chat.json": [
		65789,
		5789
	],
	"./pt/common.json": [
		93862,
		3862
	],
	"./pt/countries.json": [
		43622,
		3622
	],
	"./pt/error.json": [
		25728,
		5728
	],
	"./pt/explore.json": [
		16598,
		6598
	],
	"./pt/header.json": [
		43605,
		3605
	],
	"./pt/helperWidget.json": [
		763,
		763
	],
	"./pt/iconography.json": [
		1007,
		1007
	],
	"./pt/myToggle.json": [
		13654,
		3654
	],
	"./pt/onboarding.json": [
		4599,
		4599
	],
	"./pt/paywall.json": [
		83815,
		3815
	],
	"./pt/portfolio.json": [
		48289,
		8289
	],
	"./pt/seo.json": [
		90006,
		6
	],
	"./pt/settings.json": [
		11635,
		1635
	],
	"./pt/subscription.json": [
		40156,
		156
	],
	"./pt/trading.json": [
		5245,
		5245
	],
	"./pt/turbo-chart.json": [
		62264,
		2264
	],
	"./pt/widget.json": [
		81871,
		1871
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64085;
module.exports = webpackAsyncContext;